import React from "react";
import { Route, Redirect } from "react-router-dom";
import Cookies from 'js-cookie';
import { useAuth } from "../helpers"
import { ACCESS_TOKEN } from "../constants";
import { canAccessPath, getFirstAllowedPath } from "../constants/permissions";
import NoPermission from "../components/NoPermission";

function PrivateRoute({ component: Component, headerTitle, ...rest }) {
  const isAuthenticated = useAuth()
  const accessToken = Cookies.get(ACCESS_TOKEN);

  const renderAllowed = (props) => {
    if (canAccessPath(props.match.path)) return <Component {...props} />;
    const fallback = getFirstAllowedPath();
    return fallback ? <Redirect to={fallback} /> : <NoPermission />;
  };

  return (
    <Route
      {...rest}
      render={(props) =>
        accessToken ? (
          <div>
            {renderAllowed(props)}
          </div>
        ) : (
            <Redirect to="/" />
          )
      }
    />
  )
}

export default PrivateRoute;
